import SpeakersConfiguration from '@/configurations/content/speakers'
import PartnersConfiguration from '@/configurations/content/partners-dark' // @/configurations/content/partners-dark для темной темы

export default {
  logo: {
    image: require('@/assets/logo/logo-white.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'Mashroom logo'
  },
  aboutActivity: {
    name: 'Демо лендинг',
    description: [
      'В конференции приняли участие больше 20 тысяч зрителей из 106 стран мира. 5-ая ежегодная конференция по искусственному интеллекту "Время вперед!" завершилась. В ней приняли участие в режиме онлайн представители бизнеса, ученые, менеджеры и заинтересованные зрители из 106 стран мира. Дискуссии о ключевых трендах и проблемах развернулись в рамках пяти сессий, их трансляция велась в прямом эфире ведущих российских и международных площадок.',
      'Второй абзац ))'
    ],
    date: '10.05.2022',
    time: '18:00'
  },
  activities: ['DpaaYmQL', 'tratPotG'], // что бы добавить новое мероприятие необходимо добавить в массив hash мерпориятия (['hash1', 'hash2'])
  speakers: SpeakersConfiguration,
  partners: PartnersConfiguration,
  footer: {
    copyright: '© Mashroom.',
    phone: '+7 926 260 53 22'
  }
}
